import React from "react"

interface SectionHeadingProps {
  children?: React.ReactNode
}

const SectionHeading: React.FC<SectionHeadingProps> = ({ children }) => (
  <h2 className="font-sans-heading clear-both mb-0 pb-0 text-xl font-bold">{children}</h2>
)

export default SectionHeading
